module.exports = __webpack_public_path__ + "static/reviews-9a572858c1c23d79a8d11b389507e3ee.png";